import { IDmDoiTuongMienGiam } from "../../model/respone/mien-giam/IDmDoiTuongMienGiam";
import { apiClient } from "../apiClient";
export const HINH_THUC_ENDPOINT = "mien-giam/hinh-thuc";
export const hinhThucApi = {
  SelectAll: () => apiClient.get(`${HINH_THUC_ENDPOINT}`),
  Insert: (payload: IDmDoiTuongMienGiam) =>
    apiClient.post(`${HINH_THUC_ENDPOINT}`, payload),
  Update: (payload: IDmDoiTuongMienGiam) =>
    apiClient.put(`${HINH_THUC_ENDPOINT}`, payload),
  Delete: (id: number) => apiClient.delete(`${HINH_THUC_ENDPOINT}/${id}`),
};
